import React from "react";
import { PhaseInfoDialogButton } from "./PhaseInfoDialogButton.jsx";

export const PhaseSectionElement = ({ title_key }) => {
    return (
        <>
            <label>{I18n.t(title_key)}</label>
            <PhaseInfoDialogButton title={I18n.t(title_key)} info={I18n.t(`${title_key}_info`)} />
        </>
    );
};
